// @flow

import * as React from "react";
import { useInView } from "react-intersection-observer";

import { type ImageType } from "../../types";
import pubSub from "../../utils/pubsub";

type PropsType = {
    src?: string,
    srcset?: string,
    mime?: string,
    alt?: string,
    className?: string,
    aspectRatio?: string,
    image?: ImageType,
    size?: any,
    style?: Object,
    skeleton?: boolean,
};

const Video = ({ className, ...props }: PropsType): React.Node => {
    const cssBaseClass = "image";
    const classList = [cssBaseClass];
    if (className) {
        classList.push(className);
    }

    // set src and alt props automatically based off image object prop
    let autoProps;
    if (props.image) {
        const src =
            (props.size && props.image.sizes
                ? props.image.sizes[props.size]
                : props.image.url) || props.image.url;
        autoProps = {
            src: src,
            alt: props.image.alt,
        };
    } else {
        autoProps = {
            // src: props.src,
            // srcset: props.srcset,
            alt: props.alt,
        };
    }

    // set initial load in style (fade from 0 opacity)
    let intialStyles = {
              opacity: 1,
          }

    // set forced aspect ratio (croppped image)
    let heightPercentage = "auto";
    if (props.aspectRatio) {
        const width = props.aspectRatio
            ? Number(props.aspectRatio.split(":")[0])
            : null;
        const height = props.aspectRatio
            ? Number(props.aspectRatio.split(":")[1])
            : null;

        if (width && height) {
            // calculate aspect ratio as padding bottom percent style
            heightPercentage = `${(height / width) * 100}%`;

            // set image styles to fill aspect ratio area and crop (cover style)
            intialStyles = {
                ...intialStyles,
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                objectFit: "cover",
                fontFamily: "object-fit: cover",
            };
        }
    }

    return (
        <div
            className={classList.join(" ")}
            style={{
                display: heightPercentage === "auto" ? "inline-flex" : "block",
                paddingBottom: heightPercentage,
                ...props.style,
            }}
        >
            <video
                alt=""
                {...autoProps}
                className={`${cssBaseClass}__image`}
                style={{ ...intialStyles }}
                autoPlay
                loop
                muted
                playsInline
                controls={false}
            >
                <source src={props.src} type={props.mime}></source>
                Video not supported
            </video>
        </div>
    );
};

export default Video;
